export const config = {
    "theme": {
        "bs-primary-color": "#2331B5",
        "bs-secondary-color": "#3EDDBF",
        "bs-text-primary-color": "#135963",
        "bs-text-secondary-color": "#5c5c5c",
        "bs-text-white": "#fff",
        "bs-text-mandatory": "#ff0000",
        "bs-breadcrumb-color": "#ededed",
        "bs-active-breadcrumb-color": "#000000",
        "bs-disabled-color": "#ededed",
        "bs-border-color": "#ededed",
        "bs-hr": "#ededed",
        "bs-table-border": "#ededed",
        "bs-table-header": "#d7e7ea",
        "bs-table-row": "#f2f2f2",
        "bs-toast-header": "#d7e7ea",
        "bs-theme-background-color": "#185581"
    },
    "logo": {
        "loader": "assets/images/logo/clearwater/clearwaterLoader.jpg",
        "main": "assets/images/logo/clearwater/clearwaterMain.jpg",
        "favicon": "assets/images/favicon/clearwater/favicon.ico",
        "banner": "assets/images/banners/trinity/banner.jpg",
        "loginBanner": "assets/images/background/trinity/trinity-bg-image.jpg"
    },
    "contact": {
        "copyright": "",
        "phone": "",
        "servicePhone": "",
        "salesPhone": "",
        "fax": "",
        "email": "",
        "serviceEmail": "",
        "salesEmail": "",
        "address": {
            "lineOne": "",
            "lineTwo": "",
            "lineThree": ""
        }
    },
    "configuration": {
        "siteTitle": "Clearwater - Billing Portal",
        "header": true,
        "footer": false,
        "privacyLink": true,
        "termsLink": true,
        "maintenance": true
    }
};